import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function TrashCanIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M10.444 4.4v-.48c0-.672 0-1.008-.133-1.265a1.2 1.2 0 0 0-.534-.524C9.516 2 9.173 2 8.49 2h-.98c-.684 0-1.027 0-1.288.13-.23.116-.417.3-.534.525-.133.257-.133.593-.133 1.265v.48m1.222 3.3v3m2.444-3v3M2.5 4.4h11m-1.222 0v6.72c0 1.008 0 1.512-.2 1.897a1.8 1.8 0 0 1-.801.787C10.885 14 10.37 14 9.344 14H6.656c-1.027 0-1.54 0-1.933-.196a1.8 1.8 0 0 1-.801-.787c-.2-.385-.2-.889-.2-1.897V4.4" /></svg>
  );
}

export default TrashCanIcon;
